<template>
	<div>
		<ol
			v-if="crumbs.length"
			class="breadcrumb m-0 inline-block list-none divide-x divide-gray-400 p-0 md:flex"
		>
			<li
				v-for="(crumb, index) in crumbs"
				:key="index"
				class="breadcrumb-item inline-block items-center leading-none md:flex"
				:class="[
					index !== crumbs.length - 1 ? 'active' : '',
					index === 0 ? 'pr-2' : 'px-2',
				]"
			>
				<CarbarLink
					v-if="index !== crumbs.length - 1"
					:href="crumb.url"
					:target="linkTarget(crumb)"
					:class="[crumb.url ? 'text-xsm no-underline' : '']"
					:text="crumb.title"
				/>
				<div v-else class="text-xsm font-medium text-gray-700">
					{{ crumb.title }}
				</div>
			</li>
		</ol>
	</div>
</template>

<script setup>
import CarbarLink from '@/components/links/CarbarLink.vue'

const props = defineProps({
	crumbs: {
		type: [Array, Object],
		required: true,
	},
})

const linkTarget = (crumb) => (crumb.target ? crumb.target : '')
</script>
